import { render, staticRenderFns } from "./SubaccountHeader.vue?vue&type=template&id=53b59c58&scoped=true&"
import script from "./SubaccountHeader.vue?vue&type=script&lang=js&"
export * from "./SubaccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubaccountHeader.vue?vue&type=style&index=0&id=53b59c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b59c58",
  null
  
)

export default component.exports